/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetRoleResourceForUser200ResponseInner
 */
export interface GetRoleResourceForUser200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRoleResourceForUser200ResponseInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleResourceForUser200ResponseInner
     */
    'resourceScope': GetRoleResourceForUser200ResponseInnerResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetRoleResourceForUser200ResponseInner
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRoleResourceForUser200ResponseInner
     */
    'role': GetRoleResourceForUser200ResponseInnerRoleEnum;
}

export const GetRoleResourceForUser200ResponseInnerResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type GetRoleResourceForUser200ResponseInnerResourceScopeEnum = typeof GetRoleResourceForUser200ResponseInnerResourceScopeEnum[keyof typeof GetRoleResourceForUser200ResponseInnerResourceScopeEnum];
export const GetRoleResourceForUser200ResponseInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type GetRoleResourceForUser200ResponseInnerRoleEnum = typeof GetRoleResourceForUser200ResponseInnerRoleEnum[keyof typeof GetRoleResourceForUser200ResponseInnerRoleEnum];


